import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import CpComplianceSvc from "@/services/CpComplianceService";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "cp-compliance"
})
class CpComplianceModule extends VuexModule {
  sessions: any[] = [];
  currentSession: any = null;
  definitions: any[] = [];
  definitionsMeta: any = null;
  dashboard: any = null;
  rekapHarian: any[] = [];
  loading = false;
  pagination: any = null;

  @Mutation SET_SESSIONS(val: any[]) {
    this.sessions = val;
  }

  @Mutation SET_CURRENT_SESSION(val: any) {
    this.currentSession = val;
  }

  @Mutation SET_DEFINITIONS(val: any[]) {
    this.definitions = val;
  }

  @Mutation SET_DEFINITIONS_META(val: any) {
    this.definitionsMeta = val;
  }

  @Mutation SET_DASHBOARD(val: any) {
    this.dashboard = val;
  }

  @Mutation SET_REKAP_HARIAN(val: any[]) {
    this.rekapHarian = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_PAGINATION(val: any) {
    this.pagination = val;
  }

  @Action async loadDefinitions(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await CpComplianceSvc.getDefinitions({ aktif: 1, ...(params || {}) });
      const resp = dt.data;
      this.SET_DEFINITIONS(resp.data || []);
      this.SET_DEFINITIONS_META(resp.meta || null);
    } catch {
      this.SET_DEFINITIONS([]);
      this.SET_DEFINITIONS_META(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadSessions(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await CpComplianceSvc.getList(params);
      const resp = dt.data;
      this.SET_SESSIONS(resp.data?.data || []);
      this.SET_PAGINATION({
        current_page: resp.data?.current_page,
        last_page: resp.data?.last_page,
        total: resp.data?.total,
        per_page: resp.data?.per_page,
      });
    } catch {
      this.SET_SESSIONS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async loadDetail(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await CpComplianceSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_SESSION(data || null);
    } catch {
      this.SET_CURRENT_SESSION(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadDashboard(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await CpComplianceSvc.getDashboard(params);
      const { data } = dt.data;
      this.SET_DASHBOARD(data || null);
    } catch {
      this.SET_DASHBOARD(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadRekapHarian(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await CpComplianceSvc.getRekapHarian(params);
      const resp = dt.data;
      this.SET_REKAP_HARIAN(resp.data || []);
    } catch {
      this.SET_REKAP_HARIAN([]);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_SESSIONS([]);
    this.SET_CURRENT_SESSION(null);
    this.SET_DASHBOARD(null);
    this.SET_REKAP_HARIAN([]);
  }
}

export const storeCpCompliance = getModule(CpComplianceModule);
